"use strict";

var _toConsumableArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = exports.ModalContainer = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var react_dom_1 = require("react-dom");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_expansion_1 = require("@ryerson/frontend.expansion");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_modal_1 = require("@ryerson/frontend.modal");

var frontend_form_controls_1 = require("@ryerson/frontend.form-controls");

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_button_1 = require("@ryerson/frontend.button");

var frontend_form_controls_2 = require("@ryerson/frontend.form-controls");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var react_2 = require("@emotion/react");

var styled_1 = __importDefault(require("@emotion/styled"));

var gatsby_1 = require("gatsby");

var util_1 = require("../common/util");

var Menu_models_1 = require("../common/Menus/Menu.models");

var frontend_feature_toggles_1 = require("@ryerson/frontend.feature-toggles");

var lists = function lists(props) {
  return (0, react_2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\tbox-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 0px 17.869px rgba(0, 0, 0, 0.0417275),\n\t\t0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725);\n\tposition: relative;\n\tpadding: 20px;\n\twidth: 270px;\n"])), props.background);
};

var mainContainerStyles = function mainContainerStyles(props) {
  return (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t@media only screen and (max-width: ", ") {\n\t\twidth: 100%;\n\t\ttransition: left 0.3s linear;\n\t\tposition: absolute;\n\t\toverflow-y: auto;\n\t\toverflow-x: hidden;\n\t\tz-index: ", ";\n\t}\n"])), props.breakpoint, frontend_common_1.IndexedLayers.underlay);
};

exports.ModalContainer = (0, styled_1.default)(frontend_modal_1.Modal)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tdiv {\n\t\tz-index: ", ";\n\t}\n"])), frontend_common_1.IndexedLayers.modal);
exports.Divider = styled_1.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\topacity: 0.1;\n\tmargin-top: 20px;\n\t", ";\n"])), function (props) {
  var color = props.color;
  return (0, react_2.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\t\tborder-bottom: 1px solid ", ";\n\t\t"])), color);
});

var ShoppingLists = function ShoppingLists(_ref) {
  var storeDirectory = _ref.storeDirectory,
      isSticky = _ref.isSticky,
      setIsShoppingListExpanded = _ref.setIsShoppingListExpanded,
      isShoppingListExpanded = _ref.isShoppingListExpanded;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      white = _theme$colors$primary.white,
      secondaryBrand = _theme$colors$primary.secondaryBrand,
      gray = _theme$colors$primary.gray,
      darkGray = _theme$colors$primary.darkGray,
      lighterGray = _theme$colors$primary.lighterGray,
      primaryBrand = _theme$colors$primary.primaryBrand;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      user = _ref3.user,
      language = _ref3.localization.language,
      axiosInstance = _ref3.axiosInstance;

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      isFetchingData = _react_1$default$useS2[0],
      setIsFetchingData = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      statusDisplay = _react_1$default$useS4[0],
      setStatusDisplay = _react_1$default$useS4[1];

  var _react_1$default$useS5 = react_1.default.useState([]),
      _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
      shoppingList = _react_1$default$useS6[0],
      setShoppingList = _react_1$default$useS6[1];

  var _react_1$default$useS7 = react_1.default.useState(""),
      _react_1$default$useS8 = _slicedToArray(_react_1$default$useS7, 2),
      newListName = _react_1$default$useS8[0],
      setNewListName = _react_1$default$useS8[1];

  var _react_1$default$useS9 = react_1.default.useState(false),
      _react_1$default$useS10 = _slicedToArray(_react_1$default$useS9, 2),
      isModalOpen = _react_1$default$useS10[0],
      setIsModalOpen = _react_1$default$useS10[1];

  var _react_1$default$useS11 = react_1.default.useState(""),
      _react_1$default$useS12 = _slicedToArray(_react_1$default$useS11, 2),
      searchText = _react_1$default$useS12[0],
      setSearchText = _react_1$default$useS12[1];

  var _react_1$default$useS13 = react_1.default.useState([]),
      _react_1$default$useS14 = _slicedToArray(_react_1$default$useS13, 2),
      personalList = _react_1$default$useS14[0],
      setPersonalList = _react_1$default$useS14[1];

  var _react_1$default$useS15 = react_1.default.useState([]),
      _react_1$default$useS16 = _slicedToArray(_react_1$default$useS15, 2),
      sharedList = _react_1$default$useS16[0],
      setSharedList = _react_1$default$useS16[1];

  var _react_1$default$useS17 = react_1.default.useState(false),
      _react_1$default$useS18 = _slicedToArray(_react_1$default$useS17, 2),
      shoppingListFeature = _react_1$default$useS18[0],
      setShoppingListFeature = _react_1$default$useS18[1];

  var _ref4 = (0, frontend_feature_toggles_1.useFeatureToggles)(),
      isFeatureEnabled = _ref4.isFeatureEnabled,
      featuresList = _ref4.featuresList;

  var _react_1$default$useS19 = react_1.default.useState(false),
      _react_1$default$useS20 = _slicedToArray(_react_1$default$useS19, 2),
      hasMounted = _react_1$default$useS20[0],
      setHasMounted = _react_1$default$useS20[1];

  react_1.default.useEffect(function () {
    if (hasMounted && (featuresList === null || featuresList === void 0 ? void 0 : featuresList.length)) {
      setShoppingListFeature(isFeatureEnabled("9978-share-shopping-list"));
    }
  }, [hasMounted, featuresList]);

  var handleNewListChange = function handleNewListChange(event) {
    setNewListName(event.target.value);
  };

  var addShoppingList = function addShoppingList() {
    setIsShoppingListExpanded(false);
    setIsModalOpen(true);
  };

  var PERSONAL_LIST_LENGTH = 5;
  var MOST_RECENT_LISTS = 3;

  var getShoppingList = function getShoppingList() {
    setIsFetchingData(true);
    setStatusDisplay((0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      justifyContent: "center",
      css: {
        padding: "20px 0"
      },
      children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "sm",
        children: frontend_common_1.withTranslation["loading"][language]
      })
    }));
    var url = "".concat(frontend_common_1.ApiUrl.SHOPPING_LIST);
    axiosInstance.get(url).then(function (response) {
      var responseData = response === null || response === void 0 ? void 0 : response.data;

      if (responseData.length) {
        setShoppingList(responseData.map(function (row, index) {
          return Object.assign(Object.assign({}, row), {
            id: index
          });
        }));
      } else {
        setStatusDisplay((0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          justifyContent: "center",
          css: {
            padding: "20px 0"
          },
          children: [(0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            icon: "warning",
            size: "sm",
            color: "tertiary"
          }), frontend_common_1.withTranslation["noRecordFound"][language]]
        }));
      }

      setIsFetchingData(false);
    }).catch(function (err) {
      console.warn(err);
      setIsFetchingData(false);
      setStatusDisplay((0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        justifyContent: "center",
        css: {
          padding: "20px 0"
        },
        children: [(0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
          icon: "error",
          size: "sm",
          color: "tertiary"
        }), frontend_common_1.withTranslation["error"][language]]
      }));
    });
  };

  var addNewShoppingList = function addNewShoppingList() {
    if (newListName.length > 0) {
      var body = {
        name: newListName
      };
      axiosInstance.post("".concat(frontend_common_1.ApiUrl.SHOPPING_LIST), body).then(function (response) {
        var responseData = response === null || response === void 0 ? void 0 : response.data;

        if (responseData) {
          setShoppingList([{
            shoppingListId: responseData.shoppingListId,
            name: responseData.name,
            itemCount: responseData.itemCount,
            userType: responseData.userType,
            sharedWith: responseData.sharedWith,
            createdDate: responseData.createdDate,
            updatedDate: responseData.updatedDate,
            sharedList: responseData.sharedList
          }].concat(_toConsumableArray(shoppingList)));
          setIsShoppingListExpanded(!isShoppingListExpanded);
          setNewListName("");
          setIsModalOpen(false);
          (0, gatsby_1.navigate)(storeDirectory + Menu_models_1.AccountMenuItemUrl.shoppingList + "/" + responseData.shoppingListId, {
            state: {
              shoppingList: responseData
            }
          });
        }
      }).catch(function (error) {
        console.warn(error);
        setIsModalOpen(false);
        setStatusDisplay((0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          justifyContent: "center",
          css: {
            padding: "20px 0"
          },
          children: [(0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            icon: "error",
            size: "sm",
            color: "tertiary"
          }), frontend_common_1.withTranslation["error"][language]]
        }));
      });
    }
  };

  var openNewShoppingListModal = function openNewShoppingListModal() {
    return (0, jsx_runtime_1.jsx)(frontend_modal_1.Modal, {
      title: frontend_common_1.withTranslation["createListTitle"][language],
      closable: true,
      isOpen: isModalOpen,
      onClose: function onClose() {
        setNewListName("");
        setIsModalOpen(false);
      },
      buttonArea: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        css: {
          width: "100%"
        },
        children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
          paddingType: "relaxed",
          label: frontend_common_1.withTranslation["createList"][language],
          onClick: addNewShoppingList,
          disabled: newListName.length < 1
        })
      }),
      dataTestId: "shopping-list-new-modal",
      children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        direction: "column",
        css: {
          marginTop: "10px",
          width: "500px"
        },
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          css: {
            marginBottom: 11
          },
          children: (0, jsx_runtime_1.jsx)(frontend_form_controls_1.Input, {
            label: frontend_common_1.withTranslation["listName"][language],
            value: newListName,
            onChange: handleNewListChange,
            language: language,
            dataTestId: "shopping-list-new-item-name"
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          css: {
            marginBottom: 15
          },
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "sm",
            autoResize: false,
            color: gray,
            children: shoppingListFeature ? frontend_common_1.withTranslation["featureSaveProductText"][language] : (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
              children: [frontend_common_1.withTranslation["saveProductText"][language], " ", (0, jsx_runtime_1.jsx)("br", {}), frontend_common_1.withTranslation["allListText"][language], " "]
            })
          })
        }), !shoppingListFeature && (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
          css: {
            marginBottom: 40
          },
          children: [(0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            icon: "chevron-down",
            size: "md",
            circled: true,
            color: white,
            css: {
              marginRight: 10,
              background: primaryBrand
            }
          }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            color: secondaryBrand,
            weight: "bold",
            children: frontend_common_1.withTranslation["learnMore"][language]
          })]
        })]
      })
    });
  };

  var handleIconClicked = function handleIconClicked(event) {
    if (searchText === null || searchText === void 0 ? void 0 : searchText.length) {
      setSearchText("");
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      if (searchText !== "") {
        sessionStorage.setItem(frontend_common_1.SessionItems.searchShippingList, searchText);
        setIsShoppingListExpanded(!isShoppingListExpanded);
        (0, gatsby_1.navigate)(storeDirectory + Menu_models_1.AccountMenuItemUrl.shoppingList);
      }
    }
  };

  react_1.default.useEffect(function () {
    if (user && user.isLoggedIn && isShoppingListExpanded) {
      getShoppingList();
    }
  }, [isShoppingListExpanded]);
  react_1.default.useEffect(function () {
    setIsModalOpen(false);
  }, []);
  react_1.default.useEffect(function () {
    setHasMounted(true);
  }, []);
  react_1.default.useEffect(function () {
    if (shoppingList.length) {
      var shared = [];
      var personal = [];

      for (var i = 0; i < shoppingList.length; i++) {
        if (shoppingList[i].userType === "Owner") {
          personal.push(shoppingList[i]);
        } else {
          shared.push(shoppingList[i]);
        }
      }

      setPersonalList(personal);
      setSharedList(shared);
    }
  }, [shoppingList]);

  var renderShoppingListsContent = function renderShoppingListsContent() {
    return (0, jsx_runtime_1.jsxs)("div", {
      css: mainContainerStyles({
        breakpoint: theme.breakpoints.lg
      }),
      children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        direction: "column",
        style: lists({
          background: white
        }),
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: (0, jsx_runtime_1.jsx)(frontend_form_controls_2.SearchInput, {
            onKeyUp: function onKeyUp(event) {
              return handleKeyUp(event);
            },
            language: language,
            value: searchText || "",
            onChange: function onChange(e) {
              var value = e.target.value;
              setSearchText(value);
            },
            size: "sm",
            addStyle: {
              fontSize: theme.typography.fonts.sizes.sm.size
            },
            placeholder: frontend_common_1.withTranslation["searchShoppingList"][language],
            shape: "rounded",
            background: white,
            border: true,
            icon: searchText ? "close" : "search",
            onIconClick: function onIconClick(event) {
              return handleIconClicked(event);
            },
            dataTestId: "header-shopping-list-search-input"
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: (0, jsx_runtime_1.jsx)(exports.Divider, {
            theme: theme,
            color: secondaryBrand
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: (0, jsx_runtime_1.jsxs)(frontend_expansion_1.Accordion, {
            multiple: true,
            defaultOpen: searchText !== "" ? 2 : 0,
            children: [(0, jsx_runtime_1.jsx)(frontend_expansion_1.AccordionTab, {
              header: frontend_common_1.withTranslation["mostRecent"][language],
              circled: true,
              dataTabId: "0",
              children: isFetchingData ? statusDisplay : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
                children: !isFetchingData && shoppingList.length > 0 ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
                  children: shoppingList.slice(0, MOST_RECENT_LISTS).map(function (list) {
                    var shared = list.shared;
                    var userType = list.userType;
                    return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                      justifyContent: "space-between",
                      css: {
                        margin: "8px 0"
                      },
                      alignItems: "center",
                      children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
                        children: [(0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                          gatsby: (0, util_1.isGatsbyLink)(!Boolean(storeDirectory), storeDirectory),
                          css: {
                            marginRight: 5
                          },
                          to: storeDirectory + Menu_models_1.AccountMenuItemUrl.shoppingList + "/" + list.shoppingListId,
                          dataTestId: "header-shopping-list-recent-item-link",
                          children: list.name
                        }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                          color: gray,
                          size: "sm",
                          children: ["(", list.itemCount, ")"]
                        })]
                      }), shoppingListFeature && shared && userType === "Owner" && (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                        icon: "people",
                        size: "sm",
                        color: primaryBrand
                      })]
                    });
                  })
                }) : (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  alignItems: "center",
                  justifyContent: "center",
                  css: {
                    margin: "30px 0"
                  },
                  children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                    size: "sm",
                    children: frontend_common_1.withTranslation["noListToDisplay"][language]
                  })
                })
              })
            }), (0, jsx_runtime_1.jsx)(frontend_expansion_1.AccordionTab, {
              header: frontend_common_1.withTranslation["sharedWithMe"][language],
              circled: true,
              dataTabId: "1",
              children: isFetchingData ? statusDisplay : (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
                children: [!isFetchingData && sharedList.length > 0 ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
                  children: sharedList.slice(0, PERSONAL_LIST_LENGTH).map(function (list) {
                    return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                      css: {
                        margin: "8px 0"
                      },
                      alignItems: "center",
                      children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
                        children: [(0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                          gatsby: (0, util_1.isGatsbyLink)(!Boolean(storeDirectory), storeDirectory),
                          css: {
                            marginRight: 5
                          },
                          to: storeDirectory + Menu_models_1.AccountMenuItemUrl.shoppingList + "/" + list.shoppingListId,
                          dataTestId: "header-shopping-list-personal-item-link",
                          children: list.name
                        }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                          color: gray,
                          size: "sm",
                          children: ["(", list.itemCount, ")"]
                        })]
                      })
                    });
                  })
                }) : (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  alignItems: "center",
                  justifyContent: "center",
                  css: {
                    margin: "30px 0"
                  },
                  children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                    size: "sm",
                    children: frontend_common_1.withTranslation["noListToDisplay"][language]
                  })
                }), shoppingList.length > PERSONAL_LIST_LENGTH && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  justifyContent: "center",
                  children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
                    css: {
                      margin: "10px 0"
                    },
                    size: "sm",
                    shape: "rounded",
                    variant: "outline",
                    label: frontend_common_1.withTranslation["viewMore"][language],
                    onClick: function onClick() {
                      (0, gatsby_1.navigate)(storeDirectory + Menu_models_1.AccountMenuItemUrl.shoppingList);
                    },
                    dataTestId: "header-shopping-list-view-more-button"
                  })
                })]
              })
            }), (0, jsx_runtime_1.jsx)(frontend_expansion_1.AccordionTab, {
              header: frontend_common_1.withTranslation["personal"][language],
              circled: true,
              dataTabId: "2",
              children: isFetchingData ? statusDisplay : (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
                children: [!isFetchingData && personalList.length > 0 ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
                  children: personalList.slice(0, PERSONAL_LIST_LENGTH).map(function (list) {
                    var shared = list.shared;
                    var userType = list.userType;
                    return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                      justifyContent: "space-between",
                      css: {
                        margin: "8px 0"
                      },
                      alignItems: "center",
                      children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
                        children: [(0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                          gatsby: (0, util_1.isGatsbyLink)(!Boolean(storeDirectory), storeDirectory),
                          css: {
                            marginRight: 5
                          },
                          to: storeDirectory + Menu_models_1.AccountMenuItemUrl.shoppingList + "/" + list.shoppingListId,
                          dataTestId: "header-shopping-list-personal-item-link",
                          children: list.name
                        }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                          color: gray,
                          size: "sm",
                          children: ["(", list.itemCount, ")"]
                        })]
                      }), shoppingListFeature && shared && userType === "Owner" && (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                        icon: "people",
                        size: "sm",
                        color: primaryBrand
                      })]
                    });
                  })
                }) : (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  alignItems: "center",
                  justifyContent: "center",
                  css: {
                    margin: "30px 0"
                  },
                  children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                    size: "sm",
                    children: frontend_common_1.withTranslation["noListToDisplay"][language]
                  })
                }), shoppingList.length > PERSONAL_LIST_LENGTH && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  justifyContent: "center",
                  children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
                    css: {
                      margin: "10px 0 2px 0"
                    },
                    size: "sm",
                    shape: "rounded",
                    variant: "outline",
                    label: frontend_common_1.withTranslation["viewMore"][language],
                    onClick: function onClick() {
                      (0, gatsby_1.navigate)(storeDirectory + Menu_models_1.AccountMenuItemUrl.shoppingList);
                    },
                    dataTestId: "header-shopping-list-personal-view-more-button"
                  })
                })]
              })
            })]
          })
        })]
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        css: {
          background: lighterGray,
          width: "100%"
        },
        children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
          fullwidth: true,
          css: {
            padding: 20,
            width: "100%"
          },
          size: "sm",
          label: frontend_common_1.withTranslation["addShoppingList"][language],
          foreground: "light",
          background: darkGray,
          shape: "rounded",
          onClick: addShoppingList,
          dataTestId: "header-shopping-list-add-new-button"
        })
      }), isModalOpen && (0, react_dom_1.createPortal)(openNewShoppingListModal(), document.body)]
    });
  };

  return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
    children: renderShoppingListsContent()
  });
};

exports.default = ShoppingLists;